module.exports = __webpack_public_path__ + "static/media/van.57bc4721.png";